import Cookies from 'js-cookie';

const handleCloseClick = (event: Event): void => {
  const target = event.target as HTMLElement;
  const container = target.closest('.a-alert-banner');
  if (!container) return;
  const innerContainer = container.querySelector('.a-alert-banner__inner');
  const button = container.querySelector('.close-button');
  const cookieTitle = container instanceof HTMLElement ? container.dataset.slug : undefined;

  if (!innerContainer || !button ) return;

  (innerContainer as HTMLElement).style.opacity = '0';
  (button as HTMLElement).style.opacity = '0';

  container.classList.add('disappearing');
  setTimeout(() => { (container as HTMLElement).style.display = 'none'; }, 600);
  Cookies.set(cookieTitle, 'true', { expires: 30 });
};

export const initializeAlert = (): void => {
  const elements = document.getElementsByClassName('a-alert-banner');
  Array.from(elements).forEach((element: Element) => {
    const button = element.querySelector('.close-button');
    if (!button) return;
    button.addEventListener('click', handleCloseClick);
  });
};
